import React from 'react';
import { Link } from 'react-router-dom';

import './index.scss';
import { scrollTop } from 'utils';

const PrevButton = ({ label = '戻る', onClick = () => {}, link }) => {
   
  const onClickFunc = (e) => {
    scrollTop();
    onClick(e);
  };

  return (
    <Link to={link} className="PrevButton">
      <button
        className="button"
        type="button"
        onClick={onClickFunc}
      >
        {label}
      </button>
    </Link>
  );
};

export default PrevButton;